import axios from "axios";
import Country from "../models/Country.js";

import getErrorDetails from "./helpers/getErrorDetails.js";

export async function getCountries(options: any) {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/countries`,
    });

    const { data = [] } = response;

    return {
      // TODO
      // hotfix to cover edge case when country doesn't have region code
      list: data.map((country: Country) => {
        if (country.region === undefined) {
          country.region = {
            regionCode: 0,
            regionName: "Other",
          };
        }
        return country;
      }),
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
}
